export enum AddressService {
  WIFI = 'wifi',
  FIBER = 'fiber',
  PETS_ALLOWED = 'pets_allowed',
  HANDICAP_ACCESS = 'handicap_access',
  ERP = 'erp',
  OUTSIDE = 'outside',
  WAITING_ROOM = 'waiting_room',
  RELAXATION_AREA = 'relaxation_area',
  DINING_ROOM = 'dining_room',
  RESTAURANT = 'restaurant',
  SHARED_KITCHEN = 'shared_kitchen',
  GYM = 'gym',
  SHOWER = 'shower',
  PHONEBOX_COUNT = 'phonebox_count',
  SHARED_MEETING_ROOMS_COUNT = 'shared_meeting_rooms_count',
  RECEPTIONIST = 'receptionist',
  FREE_PARKING = 'free_parking',
  PAYABLE_PARKING = 'payable_parking',
  BIKE_PARKING = 'bike_parking',
  MAIL = 'mail',
  DOMICILIATION = 'domiciliation',
  BRAND_OTHER_SPACES_ACCESS = 'brand_other_spaces_access',
  FULL_TIME_ACCESS = 'full_time_access',
  BADGE_ACCESS = 'badge_access',
  ALARM = 'alarm',
}

export enum AddressCustomService {
  PARKING = 'parking',
}
